import React, { useState } from "react";
import CustomTabs from "components/tabs/customTab";
import { 
    CircleCheck,
    Clock, 
    Inbox,
    MessageCircle,
} from "lucide-react";
import MessageDashBoard from "./MessageDashBoard";

const EmployeeInboxTabs = ({ messages, selectedDepartment, getStatusDisplay }) => {
    const [activeTab, setActiveTab] = useState("All");
    
    const TabLabel = ({ icon: Icon, text, count }) => (
        <div className="flex items-center justify-center gap-2">
            <Icon className="text-slate-900 w-4 h-4 dark:text-slate-50" />
            <span className="text-sm font-medium">
                {text} ( {count} )
            </span>
        </div>
    );

    const filteredByDept =
        selectedDepartment === "All"
            ? messages
            : messages.filter((m) => m.department === selectedDepartment);

    const mainTickets = filteredByDept.filter(m => !m.tic_parent_id);

    const counts = {
        All: filteredByDept.length,
        Pending: mainTickets.filter(m => getStatusDisplay(m.ticket_status) === "pending").length,
        Responded: mainTickets.filter(m => getStatusDisplay(m.ticket_status) === "responded").length,
        Resolved: mainTickets.filter(m => getStatusDisplay(m.ticket_status) === "resolved").length,
    };

    const filteredMessages =
        activeTab === "All"
            ? filteredByDept
            : filteredByDept.filter(m => {
                if (m.tic_parent_id) return false; // replies don't have own status
                return getStatusDisplay(m.ticket_status) === activeTab.toLowerCase();
            });

    const tabOptions = [
        { label: <TabLabel icon={Inbox} text="All" count={counts.All} />, value: "All" },
        { label: <TabLabel icon={Clock} text="Pending" count={counts.Pending}/>, value: "Pending" },
        { label: <TabLabel icon={MessageCircle} text="Responded" count={counts.Responded}/>, value: "Responded" },
        { label: <TabLabel icon={CircleCheck} text="Resolved" count={counts.Resolved}/>, value: "Resolved" },
    ];


    return (
        <div className="flex flex-col gap-2 space-y-6">
            <CustomTabs
                tabs={tabOptions}
                activeTab={activeTab}
                onChange={setActiveTab}
                height="h-12"
            />
            <MessageDashBoard
                messages={filteredMessages}
                getStatusDisplay={getStatusDisplay}
            />
        </div>
    );
};

export default EmployeeInboxTabs;
